import './shared-edb133c5.css';

var sharedClasses = {"input":"prc-Checkbox-input-5xcR2"};

export { sharedClasses as default };
